import {
    Component, ChangeDetectionStrategy, Input,
    OnChanges, HostListener, Output, EventEmitter, SimpleChanges, OnInit
} from '@angular/core';
import { SelectData, SelectItem } from '../../../interfaces/filter-data';

@Component({
    selector: 'app-select',
    template: require('./select.component.html'),
    styles: [require('./select.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class SelectComponent implements OnChanges, OnInit {
    @Input()
    public data: SelectData;

    @Input()
    public isLoading = true;

    @Input()
    public defaultDisplayItem = { name: 'All', id: 0 };

    @Input()
    public errorMsg: string;

    @Output()
    public onSelectChange: EventEmitter<SelectItem[]> = new EventEmitter<SelectItem[]>();

    public filterItems: SelectItem[];

    public displayItem: SelectItem;

    public selectedItems: SelectItem[] = [];

    public showDropdownList = false;

    public toolTipData: string[];

    @HostListener('document:click', ['$event.target'])
    public onOutsideClick(targetElement: HTMLElement) {
        if (this.data && this.data.title && targetElement &&
            (targetElement.className !== `select-menu ${this.data.title} is-active`) &&
            (targetElement.className !== `dropdown-icon ${this.data.title}`) &&
            (targetElement.offsetParent &&
                targetElement.offsetParent.className.indexOf('select-menu') === -1)) {
            const isSelectMenuActive = document.getElementsByClassName(`select-menu ${this.data.title} is-active`).length;
            if (isSelectMenuActive) {
                this.showDropdownList = false;
            }
        }
    }

    public ngOnInit(): void {
        this.displayItem = this.defaultDisplayItem;
    }

    public ngOnChanges(changes: SimpleChanges) {
        if (changes.data) {
            this.selectedItems = [];
            this.filterItems = [];
            this.displayItem = this.defaultDisplayItem;
            if (this.data && this.data.listItems && this.data.listItems.length) {
                this.data.listItems.forEach(li => li.isChecked = false);
                this.filterItems = this.data.listItems;
                if (this.data.selectedItems && this.data.selectedItems.length) {
                    this.data.selectedItems.forEach((si: SelectItem) => {
                        this.updateItemChanges({ ...si, isChecked: true });
                    });
                    // this.onSelectChange.emit(this.selectedItems);
                }
                //  else {
                //     this.filterItems.forEach(li => li.isChecked = false);
                // }
            }
        }
    }

    public onSearchBoxChange(searchText: string) {
        this.filterItems = this.data.listItems.filter(item => item.name.toLowerCase().indexOf(searchText.toLowerCase()) !== -1);
    }

    public onItemChange(value: SelectItem) {
        this.updateItemChanges(value);
        if (this.data.isSingleSelect) {
            this.showDropdownList = false;
        }
        this.onSelectChange.emit(this.selectedItems);
    }

    private updateItemChanges(value: SelectItem) {
        if (value && value.id) {
            if (!this.data.isSingleSelect) {
                if (value.isChecked) {
                    this.selectedItems.push(value);
                    const filterItem = this.filterItems.find(li => li.id === value.id);
                    if (filterItem) {
                        filterItem.isChecked = true;
                    }
                } else {
                    this.selectedItems = this.selectedItems.filter(si => si.id !== value.id);
                    const filterItem = this.filterItems.find(li => li.id === value.id);
                    if (filterItem) {
                        filterItem.isChecked = false;
                    }
                }
            } else {
                this.selectedItems = value.isChecked ? [value] : [];
            }
        } else {
            this.selectedItems = [];
            this.filterItems.forEach(li => li.isChecked = false);
        }
        const selectedItemsName = this.selectedItems.map(si => si.name);
        selectedItemsName.shift();
        this.toolTipData = selectedItemsName;
        this.displayItem = this.selectedItems.length ? this.selectedItems[0] : this.defaultDisplayItem;
    }
}
